@if (!isHidden && !status?.hidden) {
    <div class="PGHeader {{status.appName == null && status.logo == null ? 'PGHeader--NoAppNameLogo' : ''}} bg-white border-bottom">
        @if(!isSwitchingLanguage) {
            <div class="PGHeader-Inner px-3 py-2" [style.backgroundColor]="status.color">
                <div>
                    <div class="PGHeader-Title">
                        <div class="PGHeader-Title-Image">
                            @if (status.backOnLogo) {
                                <button type="button" (click)="goRouteBack()" class="PGHeader-Title-Image-Link btn btn-link d-flex align-items-center h-100 p-0"
                                    [attr.aria-label]="'pg-header.a11y.back' | locTranslate">
                                    <i class="fa-regular fa-chevron-left fa-2x me-3" aria-hidden="true"></i>
                                    @if (status.logo != null) {
                                        <img [src]="status.logo" [alt]="status.appName || status.name || ''"/>
                                    }
                                </button>
                            }
                            @if (!status.backOnLogo && status.logo != null) {
                                <img [src]="status.logo" [alt]="status.appName || status.name || ''"/>
                            }
                        </div>
                        <div class="d-flex align-items-baseline">
                            @if (status.name != null) {
                                <h3 [innerHTML]="status.name | locTranslate"></h3>
                            }
                            @if (status.subName != null) {
                                <h5 [innerHTML]="status.subName | locTranslate"></h5>
                            }
                            @if (status.appName != null) {
                                <h6 [innerHTML]="status.appName | locTranslate"></h6>
                            }
                        </div>
                    </div>
                    @if (!status.backOnLogo && status.back?.url != null) {
                        <div class="PGHeader-Back pt-1">
                            <button type="button" class="btn btn-link btn-sm" (click)="goRouteBack()">
                                <i class="fa-regular fa-chevron-left" aria-hidden="true"></i>
                                @if (status.back.text != null) {
                                    <span>{{ status.back.text | locTranslate }}</span>
                                }
                                @if (status.back.text == null) {
                                    <span>{{ cleanReadableURL(status.back.url) }}</span>
                                }
                            </button>
                        </div>
                    }
                </div>
                <div>
                    <ng-content></ng-content>
                </div>
                <div class="PGHeader-Buttons d-flex align-items-center">
                    @if (newFrontendVersion != null) {
                        <div>
                            <button type="button" class="btn btn-white text-primary {{ animateNewFrontendVersion ? 'pg-animation-fadeout pg-animation-forwards' : 'pg-animation-popin' }}" (click)="reloadApplication()"
                                [attr.aria-label]="'pg-header.new-version-available' | locTranslate"
                                title="{{ 'pg-header.new-version-available' | locTranslate }}">
                                <i class="fa-regular fa-sparkles" aria-hidden="true"></i>
                            </button>
                        </div>
                    }
                    <div>
                        <app-pg-help (openChange)="onOpenChange('help', $event)"></app-pg-help>
                    </div>
                    @if (!noTasks) {
                        <div>
                            <app-pg-tasks-view (openChange)="onOpenChange('task-view', $event)"></app-pg-tasks-view>
                        </div>
                    }
                    @if (noUser || !isLoggedIn()) {
                        <div>
                            <app-pg-language-selector (openChange)="onOpenChange('language-selector', $event)"></app-pg-language-selector>
                        </div>
                    }
                    @if (!noUser && isLoggedIn()) {
                        @if (isFullyLoggedIn() && isChatEnabled()) {
                            <div class="PGHeader-Buttons-Chat" ngbDropdown [autoClose]="false" [open]="true" [container]="null">
                                <button type="button" class="btn btn-white position-relative PGHeader-Buttons-Chat-Toggle" ngbDropdownAnchor (click)="isChatVisible = !isChatVisible; onOpenChange('chat', isChatVisible);"
                                    [attr.aria-label]="'pg-header.a11y.chat' | locTranslate"
                                    [attr.aria-expanded]="isChatVisible">
                                    <i class="fa-regular fa-lg fa-comments opacity-100 m-0 text-{{isChatVisible ? 'primary' : 'dark'}}" aria-hidden="true"></i>
                                    <div class="PGHeader-Buttons-Chat-Toggle-Badges">
                                        @if (chatNotificationCount; as count) {
                                            <span class="badge bg-danger m-0 p-1">{{count}}</span>
                                        }
                                        @if (!chatNotificationCount) {
                                            @if (chatUnreadCount; as count) {
                                                <span class="badge bg-secondary m-0 p-1">{{count}}</span>
                                            }
                                        }
                                    </div>
                                </button>
                                <div ngbDropdownMenu class="PGHeader-Buttons-Chat-Menu p-0 pg-animation-fadein {{isChatVisible ? '' : 'd-none'}}">
                                    <div class="PGHeader-Buttons-Chat-Menu-Inner">
                                        <div>
                                            <app-pg-chat mode="chat" (unreadCount)="chatUnreadCount = $event;" (notificationCount)="chatNotificationCount = $event;" [isHidden]="!isChatVisible"></app-pg-chat>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                        <div>
                            <app-pg-user-menu [menuElements]="menuElements" [requiredRealms]="true" (openChange)="onOpenChange('user-menu', $event)"></app-pg-user-menu>
                        </div>
                    }
                </div>
            </div>
        }
    </div>
}
